<ng-container *ngIf="!isReadOnly">
	<div [froalaEditor]="froalaOptions" id="froalaEditor" [(froalaModel)]="html" (froalaModelChange)="onContentChange($event)"></div>
	<sl-button-bar *ngIf="!this.canDeactivate()" (canceled)="onCancel()" (submitted)="onSubmit()"></sl-button-bar>
</ng-container>
<div *ngIf="isReadOnly" [froalaView]="html"></div>
